// extracted by mini-css-extract-plugin
export default {"app":"PageLayout_app__xtQys","main":"PageLayout_main__+lorM","content":"PageLayout_content__PJlNQ"};